import requestProvider from "./axiosHandler";

const assignRoleToEmployee = ({employeeId, roleId}) => {

    return requestProvider
        .post('/role-employee/assign', {
            employeeId: employeeId,
            roleId: roleId
        })
}

const getEmployeeRolesById = (id) => {

    return requestProvider
        .get(`/role-employee/get-with-has-permission/${id}`)
}

export {getEmployeeRolesById, assignRoleToEmployee}